function Asterisk() {
    return <span className='asterisk'>*</span>;
}

export default Asterisk;
